var _path;
import * as React from "react";
function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.102 2c1.195 0 2.32.492 3.164 1.336l6.398 6.398c.844.844 1.336 1.97 1.336 3.164V33.5c0 2.531-2.04 4.5-4.5 4.5h-21C6.969 38 5 36.031 5 33.5v-27C5 4.04 6.969 2 9.5 2h14.602zM9.5 5.375c-.633 0-1.125.563-1.125 1.125v27A1.11 1.11 0 009.5 34.625h21c.563 0 1.125-.492 1.125-1.125V13.25H26A2.221 2.221 0 0123.75 11V5.375H9.5z"
  })));
}
export default SvgDoc;